/** Author-written end labels for a rating_scale question (spec 36-04). Guarded at render, not on save. */

export interface RatingScaleLabels {
  min: string;
  max: string;
}

// The shipped literals, so an untouched survey is byte-identical on screen.
export const RATING_SCALE_LABEL_DEFAULTS: RatingScaleLabels = {
  min: 'Not at all',
  max: 'Extremely',
};

export const RATING_SCALE_LABEL_MAX_LENGTH = 40;

export function resolveRatingScaleLabels(
  question?: { scale_min_label?: string; scale_max_label?: string } | null,
): RatingScaleLabels {
  // Trimmed again after the cut, which can land on a space mid-label.
  const one = (raw: string | undefined, fallback: string) =>
    (raw ?? '').trim().slice(0, RATING_SCALE_LABEL_MAX_LENGTH).trim() || fallback;
  return {
    min: one(question?.scale_min_label, RATING_SCALE_LABEL_DEFAULTS.min),
    max: one(question?.scale_max_label, RATING_SCALE_LABEL_DEFAULTS.max),
  };
}
